import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { motion } from 'framer-motion';
export function PricingCards() {
  const [selected, setSelected] = useState<'standard' | 'elite'>('elite');
  return <section id="pricing" className="py-14 bg-[#1a1a1a]" data-id="element-248">
      <div className="max-w-2xl mx-auto px-4 md:px-8" data-id="element-249">
        {/* Urgency Header */}
        <div className="text-center mb-10 max-w-3xl mx-auto" data-id="element-250">
          <h2 className="text-xl md:text-2xl font-bold text-white mb-4 uppercase tracking-wider" data-id="element-251">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mb-5" data-id="element-252">
            <CountdownTimer data-id="element-253" />
          </div>
          <div className="bg-red-900/30 text-red-400 p-3 rounded-lg border border-red-800 font-medium mb-5 flex items-center justify-center gap-2" data-id="element-254">
            <span data-id="element-255">⚠️</span> Después sube $8.000 ARS. No vuelve.
          </div>

          <div className="mb-3 text-white font-bold flex items-center justify-center gap-2" data-id="element-256">
            <span className="w-3 h-3 rounded-full bg-red-500 animate-pulse" data-id="element-257"></span>
            Quedan pocos cupos al precio de lanzamiento
          </div>

          <div className="w-full bg-gray-700 rounded-full h-4 mb-1 overflow-hidden" data-id="element-258">
            <motion.div className="bg-red-500 h-4 rounded-full" initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} data-id="element-259" />
          </div>
          <p className="text-sm text-gray-400 font-medium text-right" data-id="element-260">
            68% de los cupos ya tomados
          </p>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-8" data-id="element-261">
          ELEGÍ TU <span className="text-green-500" data-id="element-262">PACK</span>
        </h2>

        <div className="flex flex-col gap-5" data-id="element-263">
          {/* Standard Pack */}
          <button type="button" onClick={() => setSelected('standard')} className={`w-full text-left rounded-2xl p-6 transition-all duration-300 border-2 ${selected === 'standard' ? 'border-green-500 bg-[#222222]' : 'border-gray-700 bg-[#222222]'}`} data-id="element-264">
            <div className="flex items-start gap-4" data-id="element-265">
              <div className="mt-1 flex-shrink-0" data-id="element-266">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'standard' ? 'border-green-500' : 'border-gray-500'}`} data-id="element-267">
                  {selected === 'standard' && <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-268" />}
                </div>
              </div>

              <div className="flex-1" data-id="element-269">
                <div className="text-2xl mb-2" data-id="element-270">📘</div>
                <div className="flex flex-wrap items-start justify-between gap-2" data-id="element-271">
                  <div data-id="element-272">
                    <h3 className="text-xl font-bold text-white leading-tight" data-id="element-273">
                      MIGA MASTER PRO
                    </h3>
                    <p className="text-gray-400 text-sm mt-1" data-id="element-274">
                      2 Tomos + 3 Bonos
                    </p>
                    <p className="text-green-500 text-sm font-medium mt-2" data-id="element-275">
                      Ideal para: Emprender desde casa
                    </p>
                  </div>
                  <div className="text-right" data-id="element-276">
                    <div className="text-gray-500 line-through text-base" data-id="element-277">
                      $45.000
                    </div>
                    <div className="text-3xl md:text-4xl font-bold text-white" data-id="element-278">
                      $19.999
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </button>

          {/* Elite Pack */}
          <button type="button" onClick={() => setSelected('elite')} className={`w-full text-left rounded-2xl p-6 transition-all duration-300 border-2 ${selected === 'elite' ? 'border-green-500 bg-[#222222]' : 'border-gray-700 bg-[#222222]'}`} data-id="element-279">
            <div className="flex items-start gap-4" data-id="element-280">
              <div className="mt-1 flex-shrink-0" data-id="element-281">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'elite' ? 'border-green-500' : 'border-gray-500'}`} data-id="element-282">
                  {selected === 'elite' && <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-283" />}
                </div>
              </div>

              <div className="flex-1" data-id="element-284">
                <div className="text-2xl mb-2" data-id="element-285">🏆</div>
                <div className="flex flex-wrap items-start justify-between gap-2" data-id="element-286">
                  <div data-id="element-287">
                    <h3 className="text-xl font-bold text-white leading-tight" data-id="element-288">
                      MIGA MASTER PRO +<br data-id="element-289" />
                      CATERING ELITE
                    </h3>
                    <div className="text-xl mt-1" data-id="element-290">⭐</div>
                    <p className="text-gray-400 text-sm mt-1" data-id="element-291">
                      2 Tomos + 3 Bonos + Kit Eventos Profesionales
                    </p>
                    <p className="text-green-500 text-sm font-medium mt-2" data-id="element-292">
                      Ideal para: Catering de eventos, bodas y empresas
                    </p>
                  </div>
                  <div className="text-right" data-id="element-293">
                    <div className="text-gray-500 line-through text-base" data-id="element-294">
                      $65.000
                    </div>
                    <div className="text-3xl md:text-4xl font-bold text-green-500" data-id="element-295">
                      $29.999
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </button>
        </div>

        {/* CTA Button */}
        <div className="mt-8" data-id="element-296">
          <a href={selected === 'elite' ? 'https://pagos.indigo33.shop/cart/44043051106392:1' : 'https://pagos.indigo33.shop/cart/44042608509016:1'} target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-6 rounded-xl transition-colors shadow-lg text-lg" data-id="element-297">
            {selected === 'elite' ? '→ QUIERO MIGA MASTER PRO + CATERING ELITE' : '→ QUIERO MI MIGA MASTER PRO'}
          </a>
        </div>
      </div>
    </section>;
}